import { User } from "../../dto/user";
import { UtilsFunctions } from "./utils-functions";
import { Stay } from "../../dto/stay";
import { Structure } from "../../dto/structure";
import { Activity } from "../../dto/activity";
import { Thematic } from "src/dto/thematic";
import { Tag } from "src/dto/tag";
import { StayFurtherInformation } from "src/dto/stayFurtherInformation";
import { Destination } from "src/dto/destination";
import { FilterDuration } from "src/dto/filterDuration";

export class CreationObject {

    public static CreateUser(object: Object) {
        return new User(
            object["id"],
            object["email"],
            object["password"],
            object["profil"],
            UtilsFunctions.StringToBoolean(object["gender"]),
            object["firstName"],
            object["lastName"],
            object["street"],
            object["city"],
            UtilsFunctions.StringToNumber(object["zipCode"]),
            UtilsFunctions.StringToNumber(object["phoneNumber"])
        );
    }

    public static CreateStructure(object: Object) {
        return new Structure(
            object["id"],
            object["email"],
            object["street"],
            object["city"],
            object["postCode"],
            object["department"],
            object["state"],
            object["country"],
            object["phone"],
            object["longitude"],
            object["latitude"],
            object["siret"],
            object["name"],
            object["description"],
            object["website"],
            object["labels"],
            object["isActive"],
            false
        );
    }

    public static CreateStay(object: Object) {
        return new Stay(
            object["id"],
            object["structureId"],
            object["title"],
            object["minYear"],
            object["maxYear"],
            object["abstract"],
            object["description"],
            object["program"],
            object["createDate"],
            object["housing"],
            object["moreInformations"],
            object["street"],
            object["postCode"],
            object["city"],
            object["conty"],
            object["state"],
            object["country"],
            object["latitude"],
            object["longitude"],
            object["phone"],
            object["partnersList"],
            object["equipmentsList"],
            object["accessesList"],
            object["furtherInformationsList"],
            object["picturesList"],
            object["activitiesList"],
            object["thematicsList"]
        );
    }

    public static CreateStayFurtherInformation(object: Object) {
        return new StayFurtherInformation(
            object["id"],
            object["stayId"],
            object["stay"],
            object["startDate"],
            object["endDate"],
            object["withTransport"],
            object["startCity"],
            object["price"],
            object["redirectionLink"],
        );
    }

    public static CreateActivity(object: Object) {
        return new Activity(
            object["id"],
            object["label"],
            false
        );
    }

    public static CreateThematic(object: Object) {
        return new Thematic(
            object["id"],
            object["label"],
        );
    }

    public static CreateTag(object: Object) {
        return new Tag(
            object["id"],
            object["label"],
        );
    }

    public static CreateDestination(object: Object) {
        return new Destination(
            object["label"],
            object["type"],
            object["postalCode"],
            object["source"],
            false,
            false,
        );
    }

    public static CreateFilterDuration(object: Object) {
        return new FilterDuration(
            object["id"],
            object["label"],
            object["minValue"],
            object["maxValue"],
            object["order"],
        );
    }
}